// angular
//   .module("HeroPRO")
//   .controller("EligibilityRequirementsController",

import './eligibilityRequirements.scss';

/* @ngInject */
export default function EligibilityRequirementsController($scope, $stateParams, $sce, $rootScope, categoryCacheService) {
    const vm = this;
    vm.showRequirements = false;
    vm.specifications = null;
    vm.mfaTerm = null;
    vm.productCode = ($stateParams.Id).split('_');
    vm.productTypeId = parseInt(vm.productCode[0]);


    function setupProductTypeData() {
        const productType = categoryCacheService.getProductTypeByProductTypeId(vm.productTypeId);

        if (productType !== null) {
            vm.productTypeNamePlural = productType.NamePlural;
            vm.specifications = $sce.trustAsHtml(productType.Specifications);
            vm.mfaTerm = productType.MaximumFinanceTerm;
        }
    }

    setupProductTypeData(); // needs to be called here for no product products

    $scope.$on('productCenter.setupComplete', () => {
        setupProductTypeData();
    });

    $scope.$on('productSearchController.showRequirements', () => {
        vm.showRequirements = !vm.showRequirements;
    });

    $scope.$on('productDetailController.isNoProductProduct', () => {
        vm.showRequirements = true;
    });
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/_shared/eligibilityrequirements/eligibilityRequirements.controller.js